import { Modal } from "../ui/modal/Modal"
import { ModalOk } from "../ui/modal/ModalOk"
import { ModalError } from "../ui/modal/ModalError"
import { msg } from "../ui/modal/utils"
import { useMemo, useState } from "react"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"

import { useQuery } from "../../hooks/useQuery"
import useFetch from "../../hooks/useFetch"
import { Trans, useTranslation } from "react-i18next"

export const ModalEditarWrd = ({ show, entry, setEntries }) => {
  const [word, setWord] = useState({
    id: entry.id,
    definicion: entry.definicion,
    definiendum: entry.definiendum,
    tags: entry.tags.map((t) => t.name),
  })

  const updateWord = useQuery(),
    showRes = useState(false)

  const runQuery = async () => {
    showRes[1](true)

    // recolecto toda la data necesaria para el fetch
    const tkn = getCookie("jwt"),
      { url, opt } = api.wrds.update({ token: tkn, word_id: word.id, word })

    // ejecuto
    updateWord.url.current = url
    updateWord.opt.current = opt

    updateWord.run({
      onOk: () => {
        setEntries((current) => ({
          total: current.total,
          entries: current.entries.map((c) => {
            if (c.id !== entry.id) return c
            return {
              ...word,
              tags: word.tags.map((t) => ({ id: -1, name: t })),
            }
          }),
        }))
      },
    })
  }

  const { t } = useTranslation()

  const BodyModalEditarPalabra = () => {
    // tags
    const { url, opt } = useMemo(() => api.tags.readAll({}), []),
      [tags, isPending, err] = useFetch({ url, opt }),
      SelectTags = () => {
        const handleClick = (tag) => {
          setWord((current) => ({
            ...current,
            tags: current.tags.includes(tag.name)
              ? current.tags.filter((t) => t !== tag.name)
              : current.tags.concat(tag.name),
          }))
        }

        if (isPending && !err) return <span>{t(`ui.btns.loading`)}...</span>

        return (
          <>
            <div className="d-flex flex-wrap">
              {tags.entries.map((tag, tix) => (
                <div key={tix} className="px-2">
                  <input
                    onChange={() => handleClick(tag)}
                    checked={word.tags.includes(tag.name)}
                    type="checkbox"
                  />
                  &nbsp;
                  {tag.name}
                </div>
              ))}
            </div>
            <hr />
            {JSON.stringify(word.tags)}
          </>
        )
      }

    return (
      <>
        <div className="p-3 pt-0" style={{ background: "hsl(0deg 0% 90%)" }}>
          <div className="form-group">
            <label className="form-label mt-4">
              {t(`admin.words.definiendum`)}
            </label>
            <input
              onChange={(e) =>
                setWord((current) => ({
                  ...current,
                  definiendum: e.target.value,
                }))
              }
              value={word.definiendum}
              className="form-control"
              placeholder={t(`admin.words.placeholder_definiendum`)}
            />
          </div>

          <div className="form-group">
            <label className="form-label mt-4">
              {t(`admin.words.definition`)}
            </label>
            <input
              onChange={(e) =>
                setWord((current) => ({
                  ...current,
                  definicion: e.target.value,
                }))
              }
              value={word.definicion}
              className="form-control"
              placeholder={t(`admin.words.placeholder_definition`)}
            />
          </div>

          <div className="form-group">
            <label className="form-label mt-4">{t(`admin.words.tags`)}</label>
            <br />
            <SelectTags />
          </div>
        </div>
      </>
    )
  }

  const footerModalEditarPalabra = () => {
    const handleCancelar = () => show[1](false)
    return (
      <>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleCancelar()}>
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-primary"
          disabled={updateWord.isPending}
          onClick={() => runQuery()}>
          {updateWord.isPending
            ? t(`ui.btns.submiting`) + "..."
            : t(`ui.btns.save`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="editar-palabra"
        show={show}
        header={<center>{t(`modals.modal_edit_word.header`)}</center>}
        body={BodyModalEditarPalabra()}
        footer={footerModalEditarPalabra()}
      />

      {/* modales para los resultados */}

      {updateWord.res && !updateWord.err && (
        <ModalOk
          show={[showRes[0], show[1]]}
          body={msg(
            <Trans
              i18nKey="modals.modal_edit_word.sucess_msg"
              values={{ word: word.definiendum }}
              components={{ i: <i /> }}
            />
          )}
        />
      )}

      {updateWord.res && updateWord.err && (
        <ModalError show={showRes} res={updateWord.res} />
      )}
    </>
  )
}
